import { render, staticRenderFns } from "./BookRelease.vue?vue&type=template&id=5e939715&scoped=true&"
import script from "./BookRelease.vue?vue&type=script&lang=js&"
export * from "./BookRelease.vue?vue&type=script&lang=js&"
import style0 from "./BookRelease.vue?vue&type=style&index=0&id=5e939715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e939715",
  null
  
)

export default component.exports